<script setup>
import { ref } from 'vue';
import { supabase } from '../lib/supabase';

const loading = ref(false);
const errorMessage = ref('');
const formEl = ref(null);

// wa-input is a form-associated custom element, but it doesn't trigger the
// browser's native implicit-submission-on-Enter behavior, so wire it up
// explicitly rather than relying on the plain <form> to catch it.
function submitOnEnter() {
  formEl.value?.requestSubmit();
}

async function onSubmit(event) {
  const formData = new FormData(event.target);
  const email = formData.get('email');
  const password = formData.get('password');

  loading.value = true;
  errorMessage.value = '';

  const { error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) {
    errorMessage.value = error.message;
  }

  loading.value = false;
}
</script>

<template>
  <wa-card class="login-card">
    <h1 slot="header">Student Sessions</h1>
    <form ref="formEl" @submit.prevent="onSubmit">
      <wa-input
        name="email"
        type="email"
        label="Email"
        autocomplete="email"
        required
        @keydown.enter="submitOnEnter"
      ></wa-input>
      <wa-input
        name="password"
        type="password"
        label="Password"
        password-toggle
        autocomplete="current-password"
        required
        @keydown.enter="submitOnEnter"
      ></wa-input>
      <wa-callout v-if="errorMessage" variant="danger">{{
        errorMessage
      }}</wa-callout>
      <wa-button type="submit" variant="brand" :loading="loading"
        >Log in</wa-button
      >
    </form>
  </wa-card>
</template>

<style scoped>
.login-card {
  max-width: 360px;
  margin: 15vh auto 0;
}

form {
  display: flex;
  flex-direction: column;
  gap: var(--wa-space-m);
}

h1 {
  margin: 0;
  font-size: var(--wa-font-size-l);
}
</style>
